import React, {Component} from 'react';
import TimezoneStore from '../stores/TimezoneStore';

import connectToStores from 'alt/utils/connectToStores';

@connectToStores
class TimezoneFieldComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: null
        };
        
        TimezoneStore.getTimezones();

    }

    static getPropsFromStores() {
        return {
            TimezoneStore: TimezoneStore.getState()
        };
    }

    static getStores() {
        return [TimezoneStore];
    }

    getOptions() {
        const timezones = this.props.TimezoneStore.timezones
        let options = [];
        if (timezones.length) {
            timezones.forEach(tz => {
                options.push(
                    <option key={tz} value={tz} label={tz}>{tz}</option>
                );
            });
        }

        return options;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.value === null && prevProps.value) {
            let value = prevProps.value;
            const timezoneInput = this.refs.timezone.getDOMNode();

            timezoneInput.value = value;
            this.setState({value});
        }
    }
    
    changeTimezone(e) {
        let value = e.target.value;

        this.setState({value});
        this.props.onChange(value);
    }

    render () {
        if (!this.props.TimezoneStore.timezonesLoaded) {
            return (<div></div>);
        }

        return (
            <div>
            <label className='form-control'>
                <div className="form-control-select">
                    <select ref="timezone" className="timezone" name='timezone' onChange={this.changeTimezone.bind(this)}>
                        {this.getOptions()}
                    </select>
                </div>
                {this.props.error ? <span className="help-block error-block">{this.props.error}</span> : ''}
            </label>
            </div>
        );
    }
}

TimezoneFieldComponent.propTypes = {
    formField: React.PropTypes.object.isRequired
};

export default TimezoneFieldComponent;



/** WEBPACK FOOTER **
 ** ./app/src/components/TimezoneFieldComponent.js
 **/